import React, {useEffect} from "react";
import {IProductCategory} from "../../models/Storefront";
import {DefaultButton, Label, Panel, PanelType, PrimaryButton, Spinner, Stack, TextField} from "@fluentui/react";
import ImageUploader from "../Inputs/ImageUploader";
import RichTextField from "../Common/RichTextField";
import NumberField from "../Inputs/NumberField";
import {
    useGetCategoryByIdQuery,
    useSaveCustomStorefrontCategoryMutation
} from "../../store/endpoints/ProductCategorizationEndpoints";
import ImageEditor from "../Inputs/ImageEditor";

export interface IProductCategoryDetailsPanelProps {
    isOpen: boolean;
    categoryIdentifier: string;
    segmentIdentifier: string;
    onDismiss: () => void;
}
const ProductCategoryDetailsPanel: React.FC<IProductCategoryDetailsPanelProps> = (props) => {
    
    const [effectiveCategory, setEffectiveCategory] = React.useState<IProductCategory>();
    const category = useGetCategoryByIdQuery({categoryIdentifier: props.categoryIdentifier, segmentIdentifier: props.segmentIdentifier }, {skip: !props.categoryIdentifier || props.categoryIdentifier === '' || !props.segmentIdentifier || props.segmentIdentifier === ''});
    const [saveCategory] = useSaveCustomStorefrontCategoryMutation()
    const [saving, setSaving] = React.useState(false);

    useEffect(() => {
        return () => {
            setSaving(false);
            setEffectiveCategory(undefined)
        }
    }, []);
    
    
    useEffect(() => {
        if(category.data) {
            setEffectiveCategory(category.data);
        }
    }, [props.categoryIdentifier, props.segmentIdentifier, category.data]);
    return(<>
        <Panel
            onOuterClick={() => {
                console.log("swallowing modal close event")
            }}
            isOpen={props.isOpen}
            headerText={'Category Details'}
            isFooterAtBottom={true}
            type={PanelType.medium}
            onDismiss={props.onDismiss}
            onRenderFooterContent={() => (
                <div style={{'paddingTop': '1em', backgroundColor: 'white'}}>
                    <PrimaryButton
                        disabled={saving}
                        text='Save Category'
                        style={{ width: '100%', margin: '10px 0' }}
                        onClick={() => {
                            if (!effectiveCategory) return;
                            setSaving(true);
                            saveCategory({category: effectiveCategory}).unwrap().then(() => {
                                setSaving(false);
                                props.onDismiss();
                            }).catch(() => {
                                setSaving(false);
                            });
                        }}
                    />
                    <DefaultButton text='Close' style={{ width: '100%', marginBottom: '10px' }} onClick={props.onDismiss} />
                </div>
            )}
        >{effectiveCategory ?
            <Stack tokens={{childrenGap: '1em'}}>
                <TextField label='Display Name' value={effectiveCategory.label} onChange={(e, v) => setEffectiveCategory({...effectiveCategory, label: v ?? ''})} />
                <div className={'labeled-image-container'}>
                    <ImageEditor height={48} label={'Icon'} imageId={`${effectiveCategory.segmentId}_${effectiveCategory.identifier}_icon`} imageType={'productCategoryIcon'} onChange={(v) => setEffectiveCategory({...effectiveCategory, smallImageUrl: v ?? ''})} value={effectiveCategory.smallImageUrl} />
                </div>
                <div className={'labeled-image-container'}>
                    <ImageEditor label={'Image'} imageId={`${effectiveCategory.segmentId}_${effectiveCategory.identifier}_image`} imageType={'productCategoryImage'} onChange={(v) => setEffectiveCategory({...effectiveCategory, largeImageUrl: v ?? ''})} value={effectiveCategory.largeImageUrl} />
                </div>
                <RichTextField label='Description' value={effectiveCategory.description} onChange={(v) => setEffectiveCategory({...effectiveCategory, description: v})} />
                <NumberField label={'Display Priority'} value={effectiveCategory.displayPriority} onChange={(v) => setEffectiveCategory({...effectiveCategory, displayPriority:v })} />
            </Stack>
            : <Spinner>Loading</Spinner>}
        </Panel>
    </>);
}
export default ProductCategoryDetailsPanel;